module.exports = "/_next/static/images/video_id_7078011788704615726-293d417de94e5474445f05f8f45c555a.jpg";